export default __webpack_public_path__ + "static/media/bunt.a1b615f8.png";